import * as React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormHelperText from '@mui/material/FormHelperText';

interface RadioButtonsProps {
	label: string;
	name: string;
	options: { value: string | boolean; label: string }[];
	value?: string;
	onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
	disabled?: boolean;
	row?: boolean;
	required?: boolean;
	error?: boolean;
	helperText?: string;
}

const RadioButtons: React.FC<RadioButtonsProps> = ({
	label,
	name,
	options,
	value,
	onChange,
	disabled,
	row = false,
	required = false,
	error = false,
	helperText,
}) => {
	return (
		<FormControl error={error}>
			<FormLabel id={`${name}-label`}>
				{label}
				{required && <span style={{ color: '#d32f2f' }}> *</span>}
			</FormLabel>
			<RadioGroup
				aria-labelledby={`${name}-label`}
				value={value}
				name={name}
				onChange={onChange}
				row={row}
			>
				{options.map((option) => (
					<FormControlLabel
						key={option.value.toString()}
						value={option.value}
						control={<Radio />}
						label={option.label}
						disabled={disabled}
					/>
				))}
			</RadioGroup>
			{helperText && <FormHelperText>{helperText}</FormHelperText>}
		</FormControl>
	);
};

export default RadioButtons;
